// PrivateRoute.js
import React, { useEffect } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/auth.context';
import { homePathForWallet, isLegalWallet, pagesForWallet } from '../utils/constants';
import NavBar from './shared-components/NavBar';

const PrivateRoute = () => {
  const { auth, isExpired, signOut } = useAuth();
  const location = useLocation();
  const legal = isLegalWallet(auth?.username);

  // A removed wallet can still have an unexpired object in localStorage.
  // Login is the only other LEGAL_WALLETS check, and that page is skipped
  // once a session exists. Drop the session so the next load cannot restore it.
  useEffect(() => {
    if (auth && !isExpired() && !legal) signOut();
  }, [auth, isExpired, legal, signOut]);

  if (!auth || isExpired() || !legal) {
    return <Navigate to="/login" replace />;
  }

  const home = homePathForWallet(auth.username);
  if (location.pathname === '/') {
    return <Navigate to={home} replace />;
  }

  // A wallet only lands on pages its console offers. A mint-only wallet
  // deep-linking to /promos (or any non-waitlist page) goes home instead;
  // the service ACL is the real gate, this keeps the client honest.
  const allowed = pagesForWallet(auth.username).some(page =>
    location.pathname.startsWith(page.path)
  );
  if (!allowed) {
    return <Navigate to={home} replace />;
  }

  return (
    <main className="app-shell">
      <NavBar />
      <section className="app-content" aria-label="Catsaspell workspace">
        <Outlet />
      </section>
    </main>
  );
};

export default PrivateRoute;
